:host {
  font-family: var(--font-family);
  font-size: var(--font-size);
  --max-width: 1080px;
}

* {
  box-sizing: border-box;
}

.viewport-margins {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 1rem;
}

.colors-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(22rem, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}


.colors-container code {
  display: block;
  width: 100%;
  padding: 3em 1.5em;
}

.colors-container code + code {
  margin-top: 1em;
}

.colors-container code span {
  font-size: 0.875em;
  display: inline-block;
  background: var(--color-bg-default);
  padding: 0.25em 0.5em;
}

.colors-container code {
  display: flex;
  justify-content: space-between;
}

h2 {
  font-size: 1.25em;
  font-weight: 600;
  margin-bottom: 0.25em;
}